import { apiClient } from './apiClient';
import {
    EmailTemplate,
    EmailTemplateCreateDto,
    EmailTemplateUpdateDto,
    EmailSendRequest,
    EmailSendResponse,
    PaginatedResult,
    EmailLog,
    SentEmailDto
} from '../../types/types';

const BASE_URL = '/emailtemplate';

export const emailTemplateService = {
    getAllEmailTemplates: async (): Promise<PaginatedResult<EmailTemplate>> => {
        const response = await apiClient.get <PaginatedResult<EmailTemplate>>(`${BASE_URL}`);
        return response.data;
    },

    getActiveEmailTemplates: async (): Promise<EmailTemplate[]> => {
        const response = await apiClient.get<EmailTemplate[]>(`${BASE_URL}/active`);
        return response.data;
    },

    getEmailTemplateById: async (id: string): Promise<EmailTemplate> => {
        const response = await apiClient.get<EmailTemplate>(`${BASE_URL}/${id}`);
        return response.data;
    },

    createEmailTemplate: async (template: EmailTemplateCreateDto): Promise<EmailTemplate> => {
        const response = await apiClient.post<EmailTemplate>(BASE_URL, template);
        return response.data;
    },

    updateEmailTemplate: async (id: string, template: EmailTemplateUpdateDto): Promise<EmailTemplate> => {
        const response = await apiClient.put<EmailTemplate>(`${BASE_URL}/${id}`, template);
        return response.data;
    },

    deleteEmailTemplate: async (id: string): Promise<void> => {
        await apiClient.delete(`${BASE_URL}/${id}`);
    },

    sendEmail: async (request: EmailSendRequest): Promise<EmailSendResponse> => {
        const response = await apiClient.post<EmailSendResponse>(`${BASE_URL}/send`, request);
        return response.data;
    },

    previewEmail: async (templateId: string, candidateId?: string, customMessage?: string): Promise<string> => {
        const params = {
            ...(candidateId ? { candidateId } : {}),
            ...(customMessage ? { customMessage } : {})
        };
        const response = await apiClient.get<string>(
            `${BASE_URL}/${templateId}/preview`,
            { params }
        );
        return response.data;
    },

    // Get email templates that can be used for a specific stage
    getTemplatesForStage: async (stageId: string): Promise<EmailTemplate[]> => {
        const response = await apiClient.get<EmailTemplate[]>(`${BASE_URL}/for-stage/${stageId}`);
        return response.data;
    },
    getEmailLogs: async (candidateId: string): Promise<EmailLog[]> => {
        const response = await apiClient.get<EmailLog[]>(`${BASE_URL}/logs/${candidateId}`);
        return response.data;
    },
    getSentEmail: async (emailLogId: string): Promise<SentEmailDto> => {
        const response = await apiClient.get<SentEmailDto>(`${BASE_URL}/sent-email/${emailLogId}`);
        return response.data;
    }
};